import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="carousel"
export default class extends Controller {
    static targets = [ "carousel", "indicator", "counter" ]

    initialize() {
        this.indicatorTargets.forEach((indicator, index, indicators) => {
			if (index == this.index) {
				indicator.ariaCurrent = "true"
				this.counterTarget.textContent = `${index + 1}/${indicators.length}`
			} else {
				indicator.ariaCurrent = "false"
			}
        })
    }

    scroll() {
		const activeIndicatorIndex = this.activeIndicatorIndex
		
        this.indicatorTargets.forEach((indicator, index, indicators) => {
			if (index == this.index) {
				indicator.ariaCurrent = "true"
				this.counterTarget.textContent = `${index + 1}/${indicators.length}`

				const nearestIndex = index + Math.sign(index - activeIndicatorIndex)
				const nearestIndicator = indicators[nearestIndex] || indicator
				nearestIndicator.scrollIntoView({ block: "nearest" })
			} else {
				indicator.ariaCurrent = "false"
			}
        })
    }

    prev() {
        this.carousel.scrollLeft = (this.index - 1) * this.carousel.offsetWidth
    }

    next() {
        this.carousel.scrollLeft = (this.index + 1) * this.carousel.offsetWidth
    }

    move(e) {
        if (e.offsetX > this.carousel.offsetWidth / 2) {
            this.next()
        } else {
            this.prev()
        }
    }

    moveTo(e) {
        this.carousel.scrollLeft = e.params.index * this.carousel.offsetWidth
    }

    /** @type {HTMLElement} */
    get carousel() {
        return this.carouselTarget
    }

    /** @type {number} */
    get index() {
        return Math.round(this.carousel.scrollLeft / (this.carousel.offsetWidth || 1))
    }

	/** @type {number} */
	get activeIndicatorIndex() {
		return this.indicatorTargets.findIndex(e => e.ariaCurrent == "true")
	}
}
